module.exports = __webpack_public_path__ + "img/icon-aim1.7b0aeccc.svg";